import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import LaboratorySetup from './LaboratorySetup';

loadDOMComponent({
	selector: 'react-manager-laboratory-setup',
	callback: ({ container, context, props }: any) => {
		const isSuperAdmin = container.getAttribute('isSuperAdmin');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<LaboratorySetup isSuperAdmin={isSuperAdmin} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
